// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import getEmptyValueField from './getEmptyValueField'

const getSegmentEndIdsWithEmptyValue = (paths, filterSelect) => {
  const segmentEndIds = []

  const field = getEmptyValueField(filterSelect)

  const checkSegmentEndForMissingValue = (segmentEnd, field) => {
    if (!segmentEnd.getIn(field)) {
      segmentEndIds.push(segmentEnd.get('segmentEndId'))
    }
  }

  paths.forEach(path => {
    checkSegmentEndForMissingValue(path.get('site1'), field)
    checkSegmentEndForMissingValue(path.get('site2'), field)
  })

  return segmentEndIds
}

export default getSegmentEndIdsWithEmptyValue
